
(function () {
    if (document.querySelectorAll(".js-link-list-block").length > 0) {

        const linkListBlock = {
            init: () => {
                linkListBlock.toggleListLink();
            },
            toggleListLink: () => {
              
                const toggleButtons = document.querySelectorAll("#toggle-links");
               
                for (let i = 0; i < toggleButtons.length; i++) {
                    toggleButtons[i].addEventListener("click", (e) => {
                        const linkList = e.target.parentNode.parentNode.parentNode;
                        const toggleLabel = e.target.querySelector('span')
                        const showMoreLabel = e.target.dataset.labelAll;
                        const showLessLabel = e.target.dataset.labelLess;

                        linkList.classList.toggle("active");

                        if (linkList.classList.contains("active")) {
                            toggleLabel.innerText = showLessLabel;
                        }
                        else {
                            toggleLabel.innerText = showMoreLabel;
                        }
                    })
                }
            }
  
        };

        linkListBlock.init();
    }
})();